import React, { useEffect, useState } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import ElderlyIcon from "@mui/icons-material/Elderly";
import GavelIcon from "@mui/icons-material/Gavel";
import { APIURL } from '../../../configApi/apiConfig';
import axios from '../../../configApi/axiosConfig';

const parseSupaRows = (html) => {
    try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(`<table>${html}</table>`, 'text/html');
        const rows = doc.querySelectorAll('tr[data-ri]');
        return Array.from(rows).map((row) => {
            const cells = row.querySelectorAll(':scope > td');
            const detalleCell = cells[4];
            const detalle = {};
            if (detalleCell) {
                detalleCell.querySelectorAll('label').forEach((label) => {
                    const key = label.textContent.trim().replace(':', '').trim();
                    const valueCell = label.closest('td')?.nextElementSibling;
                    if (key && valueCell) detalle[key] = valueCell.textContent.trim();
                });
            }
            return {
                numeroProceso: cells[0]?.textContent.trim(),
                numeroCausa: cells[1]?.textContent.trim(),
                juzgado: cells[2]?.textContent.trim(),
                tipo: cells[3]?.textContent.trim(),
                detalle,
            };
        });
    } catch {
        return [];
    }
};




export const AuditoriaIntegral = ({ initialCedula, initialNombre, data }) => {
    const [cedula, setCedula] = useState(initialCedula || "");
    const [numerosolicitud, setNumeroSolicitud] = useState(data?.NumeroSolicitud);
    const [auditData, setAuditData] = useState(undefined);
    const [mspData, setMspData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [auditSupa, setAuditSupa] = useState([]);
    const [auditSatje, setAuditSatje] = useState([]);

    useEffect(() => {
        if (initialCedula) {
            setCedula(initialCedula);
        }
    }, [initialCedula]);

    useEffect(() => {
        if (data?.sCre_SolicitudWeb) {
            fetchAcciones();
        }
    }, [data?.sCre_SolicitudWeb]);

    const fetchAcciones = async () => {
        try {
            setLoading(true);
            const response = await axios.get(APIURL.get_audit_run(data.sCre_SolicitudWeb));
            const raw = response.data;
            const auditRun = Array.isArray(raw) ? (raw[0] ?? null) : (raw ?? null);
            setAuditData(auditRun);

            if (auditRun?.sAuditRun) {
                const responseMsp = await axios.get(APIURL.get_audit_msp_aseguradora(auditRun.sAuditRun));
                setMspData(Array.isArray(responseMsp.data) ? responseMsp.data : []);
                const AUDITA_SUPA = await axios.get(APIURL.get_audit_supa(auditRun.sAuditRun));
                setAuditSupa(Array.isArray(AUDITA_SUPA.data) ? AUDITA_SUPA.data : []);
                const audita_satje = await axios.get(APIURL.get_audit_satje_causal(auditRun.sAuditRun));
                setAuditSatje(Array.isArray(audita_satje.data) ? audita_satje.data : []);
            } else {
                setMspData([]);
                setAuditSupa([]);
                setAuditSatje([]);
            }
        } catch (error) {
            console.error("Error al consumir audit-run:", error);
            setAuditData(null);
            setMspData([]);
            setAuditSupa([]);
            setAuditSatje([]);
        } finally {
            setLoading(false);
        }
    };


    if (loading) {
        return (
            <div className="flex items-center justify-center py-10">
                <div className="h-10 w-10 animate-spin rounded-full border-4 border-blue-200 border-t-blue-600" />
            </div>
        );
    }

    if (auditData === null) {
        return (
            <div className="flex flex-col items-center justify-center gap-2 py-12">
                <InfoOutlinedIcon style={{ fontSize: 64, color: "#b0bec5" }} />
                <p className="text-lg font-semibold text-slate-500">
                    No existe información
                </p>
                <p className="text-sm text-slate-400">
                    No se encontraron registros de auditoría para esta solicitud.
                </p>
            </div>
        );
    }

    if (auditData === undefined) {
        return null;
    }

    const coberturasActivas = mspData.filter((i) => i?.estado_cobertura?.toLowerCase().includes("si registra")).length;
    const supaConProcesos = auditSupa.filter((s) => !s.sin_procesos).length;
    const satjeRegistros = auditSatje.length;
    const tieneAlertasLegales = supaConProcesos > 0 || satjeRegistros > 0;

    return (
        <div className="rounded-2xl border border-slate-200 bg-gradient-to-b from-slate-50 via-slate-100 to-slate-100 p-4 shadow-sm md:p-6">
            <div className="mb-4 overflow-hidden rounded-2xl border border-blue-200/70 bg-white">
                <div className="bg-gradient-to-r from-blue-800 via-blue-700 to-cyan-700 px-4 py-3 text-white md:px-6">
                    <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-blue-100">Perfil de riesgo crediticio</p>
                    <h2 className="mt-1 text-xl font-black leading-tight md:text-3xl">{initialNombre || "Cliente"}</h2>
                </div>
                <div className="grid grid-cols-1 gap-3 p-4 md:grid-cols-3 md:p-6">
                    <div>
                        <p className="text-[11px] font-bold uppercase tracking-wide text-slate-400">Cedula</p>
                        <p className="text-sm font-semibold text-slate-700">{cedula || "-"}</p>
                    </div>
                    <div>
                        <p className="text-[11px] font-bold uppercase tracking-wide text-slate-400">Numero Solicitud</p>
                        <p className="text-sm font-semibold text-slate-700">{numerosolicitud || "-"}</p>
                    </div>
                    <div>
                        <p className="text-[11px] font-bold uppercase tracking-wide text-slate-400">Estado legal</p>
                        <span className={`inline-flex rounded-full px-3 py-1 text-xs font-bold ${tieneAlertasLegales ? "bg-red-100 text-red-700" : "bg-emerald-100 text-emerald-700"}`}>
                            {tieneAlertasLegales ? "Con alertas" : "Sin alertas"}
                        </span>
                    </div>
                </div>
            </div>

            <div className="mb-4 grid grid-cols-1 gap-3 md:grid-cols-3">
                <div className="rounded-xl border border-emerald-200 bg-emerald-50 p-4">
                    <p className="text-[11px] font-bold uppercase tracking-wide text-emerald-600">Coberturas activas</p>
                    <p className="mt-1 text-2xl font-black text-emerald-700">{coberturasActivas}</p>
                </div>
                <div className="rounded-xl border border-amber-200 bg-amber-50 p-4">
                    <p className="text-[11px] font-bold uppercase tracking-wide text-amber-700">Procesos SUPA</p>
                    <p className="mt-1 text-2xl font-black text-amber-700">{supaConProcesos}</p>
                </div>
                <div className="rounded-xl border border-stone-200 bg-stone-50 p-4">
                    <p className="text-[11px] font-bold uppercase tracking-wide text-stone-600">Registros SATJE</p>
                    <p className="mt-1 text-2xl font-black text-stone-700">{satjeRegistros}</p>
                </div>
            </div>

            {mspData.length > 0 && (
                <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
                    <div className="mb-3 flex items-center gap-2">
                        <HealthAndSafetyIcon style={{ color: "#1f7ecf", fontSize: 20 }} />
                        <p className="text-xs font-extrabold tracking-wide text-sky-700">SALUD - MSP</p>
                    </div>
                    <hr className="mb-4 border-slate-200" />
                    <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
                        {mspData.map((item) => (
                            <div key={item.sAuditMspAseguradora} className="rounded-xl border border-slate-200 bg-slate-50 p-3 transition hover:-translate-y-0.5 hover:shadow-sm">
                                <p className="mb-1 text-sm font-extrabold text-slate-700">{item.nombre_institucion}</p>
                                <p className="mb-1 text-xs text-slate-600"><span className="font-bold">Tipo de seguro:</span> {item.tipo_seguro}</p>
                                <p className={`text-xs font-bold ${item.estado_cobertura?.toLowerCase().includes("si registra") ? "text-green-600" : "text-red-600"}`}>
                                    {item.estado_cobertura}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {auditSupa.some((s) => !s.sin_procesos) && (
                <div className="mt-4 rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
                    <div className="mb-3 flex items-center gap-2">
                        <ElderlyIcon style={{ color: "#d68f1f", fontSize: 20 }} />
                        <p className="text-xs font-extrabold tracking-wide text-amber-700">PENSIONES - SUPA</p>
                    </div>
                    <hr className="mb-4 border-slate-200" />
                    {auditSupa.filter((s) => !s.sin_procesos).map((supa) => {
                        const rows = parseSupaRows(supa.html_crudo);
                        return (
                            <div key={supa.sAuditSupa}>
                                {rows.map((row, idx) => (
                                    <div key={idx} className="mb-2 rounded-xl border border-amber-200 bg-gradient-to-r from-amber-50 to-white p-3">
                                        <div className="grid grid-cols-1 gap-2 md:grid-cols-12">
                                            <div className="md:col-span-3">
                                                <p className="text-[11px] font-bold text-amber-700">N° PROCESO</p>
                                                <p className="text-sm font-extrabold text-red-700">{row.numeroProceso || "-"}</p>
                                            </div>
                                            <div className="md:col-span-3">
                                                <p className="text-[11px] font-bold text-amber-700">N° CAUSA</p>
                                                <p className="text-xs text-slate-700">{row.numeroCausa || "-"}</p>
                                            </div>
                                            <div className="md:col-span-6">
                                                <p className="text-[11px] font-bold text-amber-700">JUZGADO</p>
                                                <p className="text-xs text-slate-700">{row.juzgado || "-"}</p>
                                            </div>
                                            <div className="md:col-span-3">
                                                <p className="text-[11px] font-bold text-amber-700">TIPO</p>
                                                <p className="text-xs text-slate-700">{row.tipo || "-"}</p>
                                            </div>
                                            {Object.entries(row.detalle).map(([key, val]) => (
                                                <div className="md:col-span-3" key={key}>
                                                    <p className="text-[11px] font-bold text-amber-700">{key.toUpperCase()}</p>
                                                    <p className="text-xs text-slate-700">{val || "-"}</p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        );
                    })}
                </div>
            )}

            {auditSatje.length > 0 && (
                <div className="mt-4 rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
                    <div className="mb-3 flex items-center gap-2">
                        <GavelIcon style={{ color: "#6a4c3d", fontSize: 20 }} />
                        <p className="text-xs font-extrabold tracking-wide text-stone-700">JUDICIAL - SATJE</p>
                    </div>
                    <hr className="mb-4 border-slate-200" />
                    <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                        {auditSatje.map((item, idx) => {
                            const visibleFields = Object.entries(item || {}).filter(([key, value]) => {
                                const lowerKey = key.toLowerCase();
                                if (lowerKey.includes("html") || lowerKey.includes("id") || lowerKey.includes("saudit")) return false;
                                return value !== null && value !== undefined && String(value).trim() !== "";
                            });

                            return (
                                <div key={item.sAuditSatjeCausa || idx} className="rounded-xl border border-stone-200 bg-stone-50 p-3">
                                    {visibleFields.length > 0 ? (
                                        visibleFields.map(([key, value]) => (
                                            <div key={key} className="mb-2">
                                                <p className="text-[11px] font-bold text-stone-500">{key.replace(/_/g, " ").toUpperCase()}</p>
                                                <p className="text-xs text-slate-700">{String(value)}</p>
                                            </div>
                                        ))
                                    ) : (
                                        <p className="text-xs text-slate-500">Sin detalle disponible.</p>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};

export default AuditoriaIntegral;
